export default "__VITE_ASSET__BLp55zCp__"